export default __webpack_public_path__ + "static/media/shareholder_example.acbcd515.png";